const darkPalette = {
    mode: 'dark' as const,
    background: {
        default: '#1a1a2e',
        paper: '#222440',
    },
    text: {
        primary: '#B4C3EF',
        secondary: '#7A8CCF',
    },
    primary: {
        light: '#7B94DF',
        main: '#5B74CF',
        dark: '#28419e',
    },
    secondary: {
        light: '#57c7c5',
        main: '#2fa5a3',
        dark: '#1C8181',
    },
    error: {
        light: '#f44336',
        main: '#ef5350',
        dark: '#d32f2f',
    },
    warning: {
        light: '#ffb74d',
        main: '#ff9800',
        dark: '#ed6c02',
    },
    action: { active: '#7B94DF' },
    info: {
        light: '#29b6f6',
        main: '#03a9f4',
        dark: '#0288d1',
    },
    success: {
        light: '#66bb6a',
        main: '#4caf50',
        dark: '#2e7d32',
    },
    sidebar: {
        main: '#1a1a2e',
    },
};

export default darkPalette;
